import axios from 'axios';

/**
 * Service for server management operations (admin only)
 */
class ServerManagementService {
    /**
     * Get server status including active sessions and processing jobs
     * 
     * @param {string} email - Admin email
     * @param {string} authToken - Authentication token
     * @returns {Promise} - Promise resolving to server status
     */
    async getServerStatus(email, authToken) {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/v3/admin/server/status`,
                {
                    headers: {
                        email: email,
                        auth: authToken,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching server status:', error);
            throw error;
        }
    }

    /**
     * Initiate server shutdown with 2-minute delay
     * 
     * @param {string} email - Admin email
     * @param {string} authToken - Authentication token
     * @returns {Promise} - Promise resolving to shutdown initiation response
     */
    async initiateShutdown(email, authToken) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v3/admin/server/shutdown`,
                {},
                {
                    headers: {
                        email: email,
                        auth: authToken,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error initiating shutdown:', error);
            throw error;
        }
    }

    /**
     * Cancel a scheduled server shutdown
     * 
     * @param {string} email - Admin email
     * @param {string} authToken - Authentication token
     * @returns {Promise} - Promise resolving to cancellation response
     */
    async cancelShutdown(email, authToken) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/v3/admin/server/shutdown/cancel`,
                {},
                {
                    headers: {
                        email: email,
                        auth: authToken,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error cancelling shutdown:', error);
            throw error;
        }
    }
}

export default new ServerManagementService();
